/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 80 80" }, this.props),
            React.createElement("path", { d: "m10.034 66.482c-6.239-7.055-10.034-16.323-10.034-26.482 0-22.091 17.909-40 40-40 22.092 0 40 17.909 40 40 0 10.159-3.794 19.427-10.033 26.482-.225-.622-.473-1.217-.749-1.771-2.076-4.152-11.13-6.957-22.261-11.13v-8.348s4.174-2.783 4.174-8.348c1.391 0 2.782-5.565 0-6.956 0-.829 3.727-7.797 2.782-12.522-1.391-6.957-20.869-6.957-22.26-1.391-8.348 0-2.783 12.782-2.783 13.913-2.782 1.391-1.391 6.956 0 6.956 0 5.565 4.174 8.348 4.174 8.348v8.348c-11.131 4.173-20.187 6.978-22.261 11.13-.276.554-.524 1.149-.749 1.771" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;